import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HttpInterceptor } from '../../../shared/interceptors/http-interceptor.service';
import { AuthenticatedWebService } from '../../../shared/services/authenticated.web.service';
import { OAuthService } from '../../user/services/oauth.service';

@Injectable()
export class TerminalService extends AuthenticatedWebService {
  constructor(
    private http: HttpInterceptor,
    oauthService: OAuthService
  ) {
    super(oauthService);
  }

  getTerminals(organizationId: string, sellerId: string, include?: string): Observable<any> {
    const url = environment.api.base_api_v3 + `organizations/${organizationId}/sellers/${sellerId}/terminals`;

    let params = new HttpParams();
    if (include) {
      params = params.set('include', include);
    }

    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(map((res: any) => res));
  }

  getSellerData(organizationId: string, sellerId: string, include?: string): Observable<any> {
    const url = environment.api.base_api_v2 + `organizations/${organizationId}/sellers/${sellerId}`;

    let params = new HttpParams();
    if (include) {
      params = params.set('include', include);
    }

    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(map((res: any) => res));
  }

  getPaymentHistoryBySellerId(sellerId: string): Observable<any> {
    const url = `${environment.api.base_url}api/v3/sellers/${sellerId}/terminals/charges`;
    return this.http.get(url, { headers: this.httpHeaders }).pipe(map((res: any) => res));
  }

}
